import { GETGROUPS_FAIL, GETGROUPS_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const getGroupDropReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETGROUPS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETGROUPS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getGroupDropReducer;
